export function aplicarCaractere(valor, caractere, maxLength = Infinity) {
    const base = valor || '';
    if (base.length >= maxLength) return base;
    return base + caractere;
}

export function aplicarBackspace(valor) {
    const base = valor || '';
    return base.slice(0, -1);
}
